import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import {
  userIsLogged,
  getRoute,
  apiDidGetAllAgentVoice,
  apiGetAvatarGenere,
  apiGetAvatarLanguages,
  apiGetAvatarVoices,
  apiUpdateApvAgent,
  apiGetAgentDocuments,
  apiDeleteAgentDocument,
  apiAddAgentDocument,
  apiGetConFile,
} from "../shared/manager/api_manager";
import AvpHeader from "../shared/header/AvpHeader";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import BreadCrumb from "../shared/header/BreadCrumb";
import { getValueByQueryString } from "../shared/manager/util";
import {
  apiGetAgentById,
  apiCreateApvAgent,
  apiUpdateAgentKnowledgeBase,
} from "../shared/manager/api_manager";
import { useLingueStore } from "../sistema/storeLingua";

import PlaylistItem from "./PlaylistItem";

const saveJson = {
  preview_name: "A",

  presenter: {
    voice: {
      type: "microsoft",
      voice_id: "it-IT-RinaldoNeural",
      access: "public",
      language: "Italian (Italy)",
    },

    type: "talk",
    source_url:
      "https://clips-presenters.d-id.com/v2/alex/qcvo4gupoy/e3nbserss8/image.png",
  },
  llm: {
    prompt_version: "v2",
    provider: "openai",
    type: "openai",
    model: "gpt-3.5-turbo",
  },
  version: 1,
};

export default function GestioneAgentAIScreen() {
  let action = getValueByQueryString("action");
  let agentId = getValueByQueryString("id");

  const navigate = useNavigate();
  const pSize = {
    // width: 640,
    height: 360,
  };
  const [formData, setFormData] = useState();
  const [formDataRefresh, setFormDataRefresh] = useState();
  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);
  const [agentDocument, setAgentDocument] = useState([]);
  const [selectedAvatarGenere, setSelectedAvatarGenere] = useState(null);
  const [avatarVoices, setAvatarVoices] = useState([]);
  const [selectedAvatarLang, setSelectedAvatarLang] = useState(null);
  const [avatarGenere, setAvatarGenere] = useState([]);
  const [avatarLanguages, setAvatarLanguages] = useState([]);
  const [selectedAvatarVoice, setSelectedAvatarVoice] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [flagChangeLanguage,setFlagChangeLanguage]=useState(false);
  // const [KnowledgeString, setKnowledgeString] = useState("");
  const { selectedLinguaTesto } = useLingueStore((state) => state);
  let breadCrumb = [
    {
      title: selectedLinguaTesto?.GestioneAgentAIBreadcrumb1,
      link: "/contenuti",
    },
    { title: selectedLinguaTesto?.GestioneAgentAIBreadcrumb2, link: null },
  ];

  function getAgentFormStorage() {
    const agentForm = localStorage.getItem("agnetForm");
    return JSON.parse(agentForm);
  }

  function setAgentFormStorage(agnetForm) {
    const agentFormString = JSON.stringify(agnetForm);
    return localStorage.setItem("agnetForm", agentFormString);
  }
  function loadAvatarVoices() {
    if (selectedAvatarLang != null && selectedAvatarGenere != null) {
      apiGetAvatarVoices(
        selectedAvatarLang.idLingua,
        selectedAvatarGenere.idGenere,
        function (response) {
          if (
            response != null &&
            response.status >= 200 &&
            response.status < 400
          ) {
            setAvatarVoices(response.data);
          }
        }
      );
    } else {
    }
  }

  useEffectOnce(() => {
    startPage();
    return () => stopPage();
  });

  useEffect(() => {
    loadAvatarVoices();
  }, [selectedAvatarLang, selectedAvatarGenere, selectedAvatarVoice, formData]);

  function startPage() {
    console.log("startPage");
    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 30)) {
        navigate("/");
      }
      initPage();
    }
  }

  useEffect(() => {
    if (formData?.idFile != null) {
      apiGetConFile(formData.idFile, function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          setSelectedFile(response.data);
          console.log("setSelectedFile", response.data);
        }
      });
    }
  }, [formData?.idFile]);

  function stopPage() {
    console.log("stopPage");
  }

  function initPage() {
    handleUpdateAgent();

    apiGetAvatarGenere(function (response) {
      let genereList = [];
      let langList = [];
      if (response != null && response.status >= 200 && response.status < 400) {
        genereList = response.data;
      }
      apiGetAvatarLanguages(function (langResp) {
        if (
          langResp != null &&
          langResp.status >= 200 &&
          langResp.status < 400
        ) {
          langList = langResp.data;
        }

        setAvatarGenere(genereList);
        setAvatarLanguages(langList);
      });
    });
    //chiamata per prendere i dati
  }

  function handleUpdateAgent() {
    const agent = getAgentFormStorage();
    if ((agentId == null && agent == null) || action == "new") {
      const newFormData = {
        greetings: "",
        preview_name: "",
        typeVoice: "",
        voice_id: "",
        languageVoice: "",
        idFile: 0,
        descFile: "",
        LLMprovider: "openai",
        knowledgeSource: "documents",
        LLMInstruction: "",
        LLMmodel: "gpt-4o-mini",
        LLMtemperature: 0.5,
        fullImage: true,
        LLMtemplate: "rag-grounded",
        knowledgeBase: "",
      };

      setFormData(newFormData);
      setFormDataRefresh(newFormData);
      setAgentFormStorage(newFormData);
    } else if (
      (agent != null && agentId != null && agent.id == agentId) ||
      (agent != null && agentId == null)
    ) {
      apiGetAgentDocuments(agentId, function (response) {
        if (response != null && response.status >= 200 && response.status < 400)
          setAgentDocument(response.data);
      });
      setFormData(agent);
      setFormDataRefresh(agent);
    } else {
      apiGetAgentById(agentId, function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          console.log(response.data);
          apiGetAgentDocuments(agentId, function (response) {
            if (
              response != null &&
              response.status >= 200 &&
              response.status < 400
            )
              setAgentDocument(response.data);
          });
          const newFormData = {
            id: response.data.avpAgent.agentId,
            preview_name: response.data.didAgent.preview_name,
            greetings: response.data.didAgent.greetings[0],
            typeVoice: response.data.didAgent.presenter.voice.type,
            voice_id: response.data.didAgent.presenter.voice.voice_id,
            fullImage: response.data.didAgent.presenter.stitch,
            gender: response.data.avpAgent.idGenere,
            languageVoice: response.data.didAgent.presenter.voice.language,
            LLMtemplate: response.data.didAgent.llm.template,
            LLMmodel: response.data.didAgent.llm.model,
            knowledgeSource:
              response.data.didAgent.llm.prompt_customization
                ?.knowledge_source ?? "documents",
            LLMInstruction: response.data.didAgent?.llm?.instructions ?? null,
            idFile: response.data.avpAgent.idFile,
            descFile: response.data.avpAgent.nomeFile,
            knowledgeBase: response.data.avpAgent.knowledgeBase,
          };
          setFormData(newFormData);
          setFormDataRefresh(newFormData);
          setAgentFormStorage(newFormData);
        }
      });
    }
  }

  function validateForm() {
    console.log("validateForm");
    if (formData === undefined || formData == null) return false;
    if (
      (formData.preview_name === undefined || formData.preview_name == null) &&
      formData.preview_name.length > 0
    )
      return false;
    if (formData.typeVoice === undefined || formData.typeVoice == null)
      return false;
    if (formData.voice_id === undefined || formData.voice_id == null)
      return false;
    if (formData.languageVoice === undefined || formData.languageVoice == null)
      return false;
    if (
      (formData.idFile === undefined || formData.idFile == null) &&
      formData.idFile !== 0
    )
      return false;

    //validazione dei campi

    return true;
  }
  // knowledgeSource;
  // LLMInstruction;
  function handleOnSave() {
    if (validateForm()) {
      // let agentId = getValueByQueryString("id");
      const newFormData = {
        greetings: [formData.greetings],
        preview_name: formData.preview_name,
        presenter: {
          voice: {
            type: formData.typeVoice,
            voice_id: formData.voice_id,
            language: formData.languageVoice,
            idGenere: formData.gender,
          },
          stitch: formData.fullImage ?? true,
          type: "talk",
          source_url: formData.idFile + "",
        },
        llm: {
          prompt_version: "v2",
          provider: "openai",
          template: formData.LLMtemplate ?? "rag-grounded",
          type: "openai",
          temperature: formData.LLMtemperature ?? 0.5,
          model: formData.LLMmodel ?? "gpt-4o-mini",
          prompt_customization: {
            knowledge_source: formData.knowledgeSource ?? "documents",
          },
          instructions: formData.LLMInstruction ?? "",
        },
        // version: 1,
      };
      if (agentId == null) {
        apiCreateApvAgent(newFormData, function (response) {
          if (
            response != null &&
            response.status >= 200 &&
            response.status < 400
          ) {
            setAlertSuccessOpen(true);
            localStorage.removeItem("agnetForm");
            navigate("/contenuti/agent?id=" + response.data.id);
            window.location.reload();
          }
        });
      } else {
        apiUpdateApvAgent(newFormData, agentId, function (response) {
          if (
            response != null &&
            response.status >= 200 &&
            response.status < 400
          ) {
            localStorage.removeItem("agnetForm");

            setAlertSuccessOpen(true);

            apiUpdateAgentKnowledgeBase(agentId, formData.knowledgeBase ?? "");
            navigate("/contenuti/agent/list");

            // window.location.reload();
          }
        });
      }
    }
  }

  function DeleteDocument(idDocument) {
    apiDeleteAgentDocument(agentId, idDocument, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        apiGetAgentDocuments(agentId, function (response) {
          if (
            response != null &&
            response.status >= 200 &&
            response.status < 400
          )
            setAgentDocument(response.data);
        });
      }
    });
  }

  function handleOnRefresh() {
    setAgentFormStorage(formDataRefresh);
    setFormData(formDataRefresh);
    navigate("/contenuti/agent/list");
  }

  function handleGenereField(event) {
    let value = event.target.value;
    let genere = null;
    if (avatarGenere != null && avatarGenere.length > 0) {
      for (let i = 0; i < avatarGenere.length; i++) {
        if (avatarGenere[i].idGenere == value) {
          genere = avatarGenere[i];
          break;
        }
      }
    }
    setSelectedAvatarGenere(genere);
  }
  function onChangeValueCheckbox(event, field) {
    const newFormData = {
      ...formData,
      [field]: event.target.checked,
    };
    setFormData(newFormData);
    setAgentFormStorage(newFormData);
  }
  function handleVoiceField(event) {
    let value = event.target.value;
    let voice = null;
    if (avatarVoices != null && avatarVoices.length > 0) {
      for (let i = 0; i < avatarVoices.length; i++) {
        if (avatarVoices[i].id == value) {
          voice = avatarVoices[i];
          break;
        }
      }
    }
    const newFormData = {
      ...formData,
      typeVoice: voice.provider,
      voice_id: voice.id,
      languageVoice: voice.languages[0].language,
      gender: selectedAvatarGenere.idGenere,
    };
    setFormData(newFormData);
    setAgentFormStorage(newFormData);
    setSelectedAvatarVoice(voice);
  }

  function onFileAdd(event) {
    if (event.target.files.length == 0) return;
    let inpFile = event.target.files[0];
    if (inpFile.size > 19500000) {
      setAlertErrorOpen(true);
      return;
    }
    const fileName = inpFile.name.toLowerCase();
    const validExtensions = [".pdf", ".txt", ".ppt", ".pptx", ".text"];
    const isValidFile = validExtensions.some((ext) => fileName.endsWith(ext));

    if (!isValidFile) {
      alert("formato file non valido ");
      return;
    }
    const formFile = new FormData();
    // Update the formData object
    formFile.append("file", inpFile, inpFile.name);
    apiAddAgentDocument(agentId, formFile, async function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        await setTimeout(5000);
        apiGetAgentDocuments(agentId, function (response) {
          if (
            response != null &&
            response.status >= 200 &&
            response.status < 400
          )
            setAgentDocument(response.data);
        });
      }
    });

    // let inpFile = event.target.files[0];
    // setInputFile({ ...inputFile, inpFile });
    // console.log(inpFile);
  }
  function handleLangField(event) {
    let value = event.target.value;
    let lang = null;
    if (avatarLanguages != null && avatarLanguages.length > 0) {
      for (let i = 0; i < avatarLanguages.length; i++) {
        if (avatarLanguages[i].idLingua == value) {
          lang = avatarLanguages[i];
          break;
        }
      }
    }
    setSelectedAvatarLang(lang);
  }
  function handleOnChangeField(event, field) {
    const newFormData = {
      ...formData,
      [field]: event.target.value,
    };
    setFormData(newFormData);
    setAgentFormStorage(newFormData);
  }

  function handleOnSelectImage() {
    navigate(
      `/contenuti/pick?action=createagent&tipocontenuto=2&agentId=${agentId}`
    );
  }

  return (
    <div id="avp-gestionecontenuti-screen">
      <AvpHeader selectedMenuId={"contenuti"} />

      <BreadCrumb items={breadCrumb} helpLink={"help.html#modificaavatar"} />
      <div id="avp-cms-screen-container">
        <Collapse
          in={alertSuccessOpen}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setAlertSuccessOpen(false);
            }, 2000);
          }}
        >
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneAgentAIAlertSuccess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneAgentAIAlertError}
          </Alert>
        </Collapse>

        <div className="avp-cms-screen-content">
          {/*  */}
          <div className="avp-cms-screen-content-col clearfix">
            <div></div>
            <div className="avp-cms-screen-content-row clearfix">
              <div className="avp-cms-screen-content-col50">
                <div className="avp-cms-screen-title">
                  {action == "new"
                    ? selectedLinguaTesto?.GestioneAgentAITitleCreate
                    : selectedLinguaTesto?.GestioneAgentAITitleEdit}
                </div>

                <div className="avp-cms-screen-content-row clearfix">
                  <div
                    className="avp-cms-screen-row-column"
                    style={{ width: "50%" }}
                  >
                    <label htmlFor="avp-form-desc" className="required">
                      {selectedLinguaTesto?.GestioneAgentAIName}
                    </label>
                    <br />
                    <input
                      id="avp-form-desc"
                      style={{ maxWidth: "none" }}
                      type="text"
                      value={formData?.preview_name ?? ""}
                      onChange={(event) =>
                        handleOnChangeField(event, "preview_name")
                      }
                    />
                  </div>
                  <br />
                  <div
                    className="avp-cms-screen-row-column"
                    style={{ width: "50%" }}
                  >
                    <label htmlFor="avp-form-desc" className="required">
                      {selectedLinguaTesto?.GestioneAgentAIGreetingsMessage}
                    </label>
                    <br />
                    <input
                      id="avp-form-desc"
                      style={{ maxWidth: "none" }}
                      type="text"
                      value={formData?.greetings ?? ""}
                      onChange={(event) =>
                        handleOnChangeField(event, "greetings")
                      }
                    />
                  </div>
                  {formData?.id !== undefined && (
                    <>
                      <label htmlFor="avp-form-LLMmodel" className="required">
                        {selectedLinguaTesto?.GestioneAgentAIGreetingsMessage}
                      </label>
                      <br />
                      <select
                        id="avp-form-LLMmodel"
                        style={{ marginTop: 20 }}
                        value={
                          formData?.LLMmodel != null ? formData?.LLMmodel : ""
                        }
                        onChange={(event) =>
                          handleOnChangeField(event, "LLMmodel")
                        }
                      >
                        <option key={1} value="gpt-35-turbo">
                          gpt-35-turbo
                          {/* {selectedLinguaTesto?.GestioneAgentAIOptionSelect} */}
                        </option>
                        <option key={2} value="gpt-4o-global">
                          gpt-4o-global
                          {/* {selectedLinguaTesto?.GestioneAgentAIOptionSelect} */}
                        </option>
                        <option key={3} value="gpt-4o-mini">
                          gpt-4o-mini
                          {/* {selectedLinguaTesto?.GestioneAgentAIOptionSelect} */}
                        </option>
                      </select>
                    </>
                  )}
                  <div className="group" style={{ marginTop: 20 }}>
                    <div className="avp-gestioneavp-nodearcs-section-title">
                      {selectedLinguaTesto?.GestioneAgentAIAgentImage}
                    </div>
                    <div>
                      <label style={{ float: "left", width: "fit-content" }}>
                        {selectedLinguaTesto?.GestioneAgentAIImageFile}
                        <br />
                        {formData?.descFile ?? ""}
                      </label>

                      <button
                        onClick={handleOnSelectImage}
                        style={{
                          marginLeft: 20,
                          width: 80,
                          float: "left",
                        }}
                      >
                        {selectedLinguaTesto?.GestioneAgentAIButtonSelect}
                      </button>
                    </div>
                  </div>
                </div>

                <br />
                <div
                  // className="avp-cms-screen-content-col50"
                  style={{ marginBottom: 40 }}
                >
                  <PlaylistItem
                    style={{ width: "fit-content" }}
                    item={selectedFile}
                    loop={false}
                    size={pSize}
                  />
                </div>
                <div className="avp-cms-screen-content-row clearfix">
                  <input
                    id="avp-form-flagGoBack"
                    type="checkbox"
                    onChange={(event) =>
                      onChangeValueCheckbox(event, "fullImage")
                    }
                    checked={
                      formData?.fullImage != null && formData.fullImage
                        ? "checked"
                        : ""
                    }
                  />
                  <label htmlFor="avp-form-flagGoBack">
                    {selectedLinguaTesto?.GestioneAgentFlagSizeImage}
                  </label>
                </div>
              </div>
             
              {formData?.id != undefined &&
              <div
                    className="group"
                    style={{ marginBottom: 20, marginTop: 20, width: "50%" }}
                  ><button onClick={()=>{setFlagChangeLanguage(!flagChangeLanguage)}}>
                cambia lingua
                </button></div>}
              {(formData?.id == undefined || flagChangeLanguage ) && selectedFile != null && (
                <>
                  <div
                    className="group"
                    style={{ marginBottom: 20, marginTop: 20, width: "50%" }}
                  >
                    <div
                    // className="avp-gestioneavp-nodearcs-section-title"
                    // style={{ position: "relative" }}
                    >
                      {selectedLinguaTesto?.GestioneAgentAIAgentVoice}
                    </div>
                    <br />

                    <div
                      // className="avp-cms-screen-content-col50"
                      style={{ width: "50%" }}
                    >
                      <label htmlFor="avp-form-genere" className={"required "}>
                        {selectedLinguaTesto?.GestioneAgentAIGender}
                      </label>
                      <br />
                      <select
                        id="avp-form-genere"
                        style={{ maxWidth: "none" }}
                        value={
                          selectedAvatarGenere != null
                            ? selectedAvatarGenere.idGenere
                            : ""
                        }
                        onChange={handleGenereField}
                      >
                        <option key={-1} value="">
                          {selectedLinguaTesto?.GestioneAgentAIOptionSelect}
                        </option>
                        {avatarGenere != null && avatarGenere.length > 0 ? (
                          avatarGenere.map((item, i) => {
                            return (
                              <option key={item.idGenere} value={item.idGenere}>
                                {item.descGenere}
                              </option>
                            );
                          })
                        ) : (
                          <option></option>
                        )}
                      </select>
                    </div>
                    <div 
                    // className="avp-cms-screen-content-row clearfix"
                    >
                      <div
                        // className="avp-cms-screen-content-col50"
                        style={{ width: "50%" }}
                      >
                        <label htmlFor="avp-form-lang" className={"required "}>
                          {selectedLinguaTesto?.GestioneAgentAILang}
                        </label>
                        <br />
                        <select
                          id="avp-form-lang"
                          style={{ maxWidth: "none" }}
                          // className={formLangStatus}
                          value={
                            selectedAvatarLang != null
                              ? selectedAvatarLang.idLingua
                              : ""
                          }
                          onChange={handleLangField}
                        >
                          <option key={-1} value="">
                            {selectedLinguaTesto?.GestioneAgentAIOptionSelect}
                          </option>
                          {avatarLanguages != null &&
                          avatarLanguages.length > 0 ? (
                            avatarLanguages.map((item, i) => {
                              return (
                                <option
                                  key={item.idLingua}
                                  value={item.idLingua}
                                >
                                  {item.descrizione}
                                </option>
                              );
                            })
                          ) : (
                            <option></option>
                          )}
                        </select>
                      </div>
                    </div>

                    <div 
                    // className="avp-cms-screen-content-row clearfix"
                    >
                      <div  
                        // className="avp-cms-screen-content-column"
                        style={{ width: "50%" }}
                      >
                        <label htmlFor="avp-form-voce" className={"required "}>
                          {selectedLinguaTesto?.GestioneAgentAIVoice}
                        </label>
                        <br />
                        <select
                          id="avp-form-voce"
                          style={{ maxWidth: "none" }}
                          // className={formVoiceStatus}
                          value={
                            selectedAvatarVoice != null
                              ? selectedAvatarVoice.id
                              : ""
                          }
                          onChange={handleVoiceField}
                        >
                          <option key={-1} value="">
                            {selectedLinguaTesto?.GestioneAgentAIOptionSelect}
                          </option>
                          {avatarVoices != null && avatarVoices.length > 0 ? (
                            avatarVoices.map((item, i) => {
                              return (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })
                          ) : (
                            <option></option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div
              // className="avp-cms-screen-content-column "
              // style={{ width: "33%" }}
              >
                {/* <p>{JSON.stringify(agentId)}</p> */}
                {formData?.id != undefined && (
                  <div
                    className="group"
                    style={{ marginTop: 20, width: "33%" }}
                  >
                    <div className="avp-gestioneavp-nodearcs-section-title">
                      {selectedLinguaTesto?.GestioneAgentAIKnowladgeBase}
                    </div>
                    <div
                      className="avp-cms-screen-row-column"
                      style={{ width: "100%" }}
                    >
                      <label htmlFor="avp-form-desc">
                        {
                          selectedLinguaTesto?.GestioneAgentAIKnowladgeBaseString
                        }
                      </label>
                      <br />
                      <textarea
                        id="avp-form-desc"
                        style={{ maxWidth: "none", width: "100%" }}
                        type="text"
                        rows={10}
                        // cols={50}
                        value={formData.LLMInstruction ?? ""}
                        onChange={(event) =>
                          handleOnChangeField(event, "LLMInstruction")
                        }
                      />
                    </div>
                    {agentDocument.length >= 5 && (
                      <p>
                        {selectedLinguaTesto?.GestioneAgentAIAlertLimitDocument}
                      </p>
                    )}
                    <br />
                    <div>
                      <input
                        id="avp-form-upload"
                        style={{ maxWidth: "none" }}
                        type="file"
                        accept=".pdf, .txt, .ppt, .pptx, .text"
                        disabled={agentDocument.length >= 5}
                        onChange={onFileAdd}
                      />
                    </div>
                    {agentDocument.map((file) => {
                      return (
                        <>
                          <div style={{ marginTop: 10 }}>
                            {file.didDocument.title}
                            <img
                              style={{ marginLeft: 10 }}
                              data-action="delete"
                              src="/images/delete_btn.svg"
                              title={
                                selectedLinguaTesto?.GestioneAgentAIImgDelete
                              }
                              onClick={() =>
                                DeleteDocument(file.avpDocument.documentId)
                              }
                            />
                          </div>
                        </>
                      );
                    })}
                    <select
                      id="avp-form-genere"
                      style={{ maxWidth: "none", marginTop: 20 }}
                      value={
                        formData.LLMtemplate != null ? formData.LLMtemplate : ""
                      }
                      onChange={(event) =>
                        handleOnChangeField(event, "LLMtemplate")
                      }
                    >
                      <option key={1} value="rag-grounded">
                        Rispondi solo con le informazioni fornite
                        {/* {selectedLinguaTesto?.GestioneAgentAIOptionSelect} */}
                      </option>
                      <option key={2} value="rag-ungrounded">
                        Rispondi utilizzando anche informazioni esterne
                        {/* {selectedLinguaTesto?.GestioneAgentAIOptionSelect} */}
                      </option>
                      <option key={3} value="assistant">
                        Non utilizza le informazioni fornite
                        {/* {selectedLinguaTesto?.GestioneAgentAIOptionSelect} */}
                      </option>
                    </select>
                  </div>
                )}
              </div>

              <br />
              <div
              // className="avp-cms-screen-content-column"
              // style={{ width: "33%" }}
              >
                <div className="group" style={{ width: "33%" }}>
                  {/* <div className="avp-gestioneavp-nodearcs-section-title">
                        {selectedLinguaTesto?.GestioneAgentAIAgentImage}
                      </div>
                      <div>
                        <label style={{ float: "left", width: "fit-content" }}>
                          {selectedLinguaTesto?.GestioneAgentAIImageFile}
                          <br />
                          {formData?.descFile ?? ""}
                        </label>

                        <button
                          onClick={handleOnSelectImage}
                          style={{
                            marginLeft: 20,
                            width: 80,
                            float: "left",
                          }}
                        >
                          {selectedLinguaTesto?.GestioneAgentAIButtonSelect}
                        </button>
                      </div>
                    </div>
                  </div>

                  <br />
                  <div
                    // className="avp-cms-screen-content-col50"
                    style={{ marginBottom: 40 }}
                  >
                    <PlaylistItem
                      style={{ width: "fit-content" }}
                      item={selectedFile}
                      loop={false}
                      size={pSize}
                    />
                  </div> */}
                  <div id="avp-footer-save-container-right">
                    <div id="avp-footer-save-submit">
                      <button onClick={handleOnSave}>
                        {selectedLinguaTesto?.GestioneAgentAIButtonSave}
                      </button>
                    </div>
                    <div id="avp-footer-save-cancel">
                      <button onClick={handleOnRefresh}>
                        {selectedLinguaTesto?.GestioneAgentAIButtonUndo}
                      </button>
                      {/* <button onClick={()=>handleCancel()} >ANNULLA</button> */}
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
}
